// src/pages/novoEvento/useNovoEvento.js
import { useMemo, useReducer } from "react";
import { novoEventoInitialState } from "./novoEvento.schema";
import { uuid } from "../../../utils/uuid"; 

function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

function setByPath(state, path, value) {
    const next = deepClone(state);
    const keys = path.split(".");
    let cur = next;
    for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
    cur[keys[keys.length - 1]] = value;
    return next;
}

function reducer(state, action) {
    switch (action.type) {
        case "RESET":
            return deepClone(novoEventoInitialState);

        case "SET":
            return setByPath(state, action.path, action.value);

        case "PATCH":
            return { ...state, ...action.value };

        case "ADD_TICKET":
            return { ...state, ingressos: [...state.ingressos, action.ticket] };

        case "UPDATE_TICKET":
            return {
                ...state,
                ingressos: state.ingressos.map((t) =>
                    t.id === action.id ? { ...t, ...action.patch } : t,
                ),
            };

        case "REMOVE_TICKET":
            return {
                ...state,
                ingressos: state.ingressos.filter((t) => t.id !== action.id),
            };

        case "ADD_LINEUP":
            return {
                ...state,
                descricao: {
                    ...state.descricao,
                    lineup: [...state.descricao.lineup, action.value],
                },
            };

        case "REMOVE_LINEUP":
            return {
                ...state,
                descricao: {
                    ...state.descricao,
                    lineup: state.descricao.lineup.filter((_, i) => i !== action.index),
                },
            };

        case "ADD_POINT":
            return {
                ...state,
                vendas: {
                    ...state.vendas,
                    pontosFisicos: [...state.vendas.pontosFisicos, action.value],
                },
            };

        case "REMOVE_POINT":
            return {
                ...state,
                vendas: {
                    ...state.vendas,
                    pontosFisicos: state.vendas.pontosFisicos.filter((_, i) => i !== action.index),
                },
            };

        case "ADD_COMMISSARY":
            return {
                ...state,
                vendas: {
                    ...state.vendas,
                    comissarios: [...state.vendas.comissarios, action.value],
                },
            };

        case "UPDATE_COMMISSARY":
            return {
                ...state,
                vendas: {
                    ...state.vendas,
                    comissarios: state.vendas.comissarios.map((c) =>
                        c.id === action.id ? { ...c, ...action.patch } : c,
                    ),
                },
            };

        case "REMOVE_COMMISSARY":
            return {
                ...state,
                vendas: {
                    ...state.vendas,
                    comissarios: state.vendas.comissarios.filter((c) => c.id !== action.id),
                },
            };

        default:
            return state;
    }
}

export function useNovoEvento(initial = null) {
    const [state, dispatch] = useReducer(reducer, initial || novoEventoInitialState);

    const actions = useMemo(
        () => ({
            reset: () => dispatch({ type: "RESET" }),
            set: (path, value) => dispatch({ type: "SET", path, value }),

            addTicket: () =>
                dispatch({
                    type: "ADD_TICKET",
                    ticket: {
                        id: uuid(),
                        nome: "",
                        lote: "Lote 1",
                        preco: 0,
                        quantidade: 0,
                        vendas: { inicio: "", fim: "" },
                        taxaAbsorvidaOrganizador: false,
                        visibilidade: "publico",
                    },
                }),
            updateTicket: (id, patch) => dispatch({ type: "UPDATE_TICKET", id, patch }),
            removeTicket: (id) => dispatch({ type: "REMOVE_TICKET", id }),

            addLineup: (value) => dispatch({ type: "ADD_LINEUP", value }),
            removeLineup: (index) => dispatch({ type: "REMOVE_LINEUP", index }),

            addPoint: (value) => dispatch({ type: "ADD_POINT", value }),
            removePoint: (index) => dispatch({ type: "REMOVE_POINT", index }),

            addCommissary: () =>
                dispatch({
                    type: "ADD_COMMISSARY",
                    value: { id: uuid(), nome: "", phone: "" },
                }),
            updateCommissary: (id, patch) => dispatch({ type: "UPDATE_COMMISSARY", id, patch }),
            removeCommissary: (id) => dispatch({ type: "REMOVE_COMMISSARY", id }),
        }),
        [],
    );

    return { state, actions };
}
